import { useMemo } from 'react';
import { useTriggerSelector } from './useTriggerSelector';

export const useInactivitySelector = () => {
  const trigger = useTriggerSelector();
  return useMemo(() => trigger.inactivity, [trigger.inactivity]);
};
